module.exports = __webpack_public_path__ + "img/267acef.jpg";